import { Component, OnInit } from '@angular/core';
import { NgProgressRef } from 'ngx-progressbar';
import { Subscription, of } from 'rxjs';
import { UploadFile } from 'src/app/models';
import { ApiOrganizationsService, DialogModalService, PermissionService } from 'src/app/services';
import { AttributesMappingManagmentComponent } from '../../dialog/attributes/mapping/attributes-mapping-managment/attributes-mapping-managment.component';
import { ProductDataUploadComponent } from '../../dialog/files/product-data-upload/product-data-upload.component';

@Component({
  selector: 'app-import',
  templateUrl: './import.component.html',
  styleUrls: ['./import.component.css']
})
export class ImportComponent implements OnInit {

  progressRef:   NgProgressRef;
  subscriptions: Subscription = new Subscription();
  btnUploadFilesMultiple: boolean = false;
  currentOrg: any;
  result: any;
  
  fileVGH: UploadFile = {
    data: null,
    inProgress: false,
    progress: 0,
    error: false,
    uploaded: false
  }
  fileSticker: UploadFile = {
    data: null,
    inProgress: false,
    progress: 0,
    error: false,
    uploaded: false
  }
  fileVGHAndStricker: UploadFile = {
    data: null,
    inProgress: false,
    progress: 0,
    error: false,
    uploaded: false
  }

  constructor(
    private apiOrganizations: ApiOrganizationsService,
    private dialogModal: DialogModalService,
    public permissionService: PermissionService
  ) { }

  ngOnInit(): void {

    this.currentOrg = this.apiOrganizations.currentOrganization;

    this.subscriptions.add(
      this.apiOrganizations.listenerCurrentOrganization().subscribe(val => {

        this.currentOrg = val;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  /**
   * 
   */
  productDataUpload(){

    let data ;
    this.dialogModal.open(data, ProductDataUploadComponent).then(

      (result) => {

        console.log("ELEMENT FROM WINDOW: ", result);
        
        if (result) {

         

        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   */
  onCreateTemplate(){

    let data;
    
    this.dialogModal.open(data, AttributesMappingManagmentComponent, 'xl').then(
      (result) => {

        console.log("ELEMENT FROM WINDOW: ", result);
        
        if (result) {

        }
      },
      () => { console.log('Rejected!'); }
    );

  }
}
